import axios from 'axios';

// Get the environment variable for the subdomain
const subdomain = process.env.REACT_APP_SHADOWSTREAM_SUB || 'genflux';

// Construct the base URL using the subdomain
const axiosInstance = axios.create({
  baseURL: `https://${subdomain}-server.shadowstream.world/api/`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
